import React, { useState } from 'react';
import { callCambiaEstado } from './utils';
import { toast } from 'react-toastify';
import ConfirmModal from '../../Elements/Modal/ConfirmModal';

export const BotoneraEstados = ({ parent, momentoCrud }) => {
    const [isRechazando, setIsRechazando] = useState(false);
    const [motivoRechazo, setMotivoRechazo] = useState("");

    if (parent.state.loading) return null;

    const estadoActual = parent.state.resource.cEstado?.value || parent.state.resource.cEstado || "R";
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const config = JSON.parse(localStorage.getItem('config') || '{}');
    const userId = user.nUsuCodigo ? user.nUsuCodigo.toString() : "";

    let isSuperAdmin = String(user.Tusu_EsSuperAdmin).toLowerCase() === "true";
    let isAprobador = config.aprobador && config.aprobador.split(',').includes(userId);
    const idAprobadorAsignado = parent.state.resource.nAprobador?.value || parent.state.resource.nAprobador;
    isAprobador = isAprobador && (userId === String(idAprobadorAsignado));
    let isPublicador = config.publicador && config.publicador.split(',').includes(userId);
    let isCreador = !isSuperAdmin && !isAprobador && !isPublicador;

    const mapaEstados = {"R": "Borrador", "X": "Por aprobar", "O": "Por publicar", "P": "Publicado", "Z": "Rechazado", "I": "Inactivo"};
    
    //sohard
    // isSuperAdmin = false; isPublicador = false; isAprobador =false; isCreador = true;
    // console.log(`Arriba) estadoActual: ${estadoActual} - ROL: super: ${isSuperAdmin ? 'SI' : 'NO'} | Pub: ${isPublicador ? 'SI' : 'NO'} | Apro: ${isAprobador ? 'SI' : 'NO'} | Crea: ${isCreador ? 'SI' : 'NO'}`);
 
    return (
        <div className="w-100">
            {(estadoActual === "R" || estadoActual === "Z") && (
                <>
                    {(isCreador || isSuperAdmin) && <button type="button" onClick={(e) => callCambiaEstado(parent, e, "Por aprobar", "")} className="btn btn-default btn-primary__submit btn-color-verdefull anchoLargo">Solicitar aprobación</button>}
                </>
            )}

            {estadoActual === "X" && (
                (isAprobador || isSuperAdmin) ? (
                    <>
                        <div className="mb-2"><span style={{ fontSize: '14px', color: '#495057' }}>El documento está pendiente de tu aprobación</span></div>
                        <div className="d-flex">
                            <button type="button" onClick={() => setIsRechazando(!isRechazando)} className="btn btn-default btn-primary__submit btn-color-rojo-borde" style={{ marginRight: '10px' }}>Rechazar</button>
                            {/* <button type="button" onClick={(e) => callCambiaEstado(parent, e, "Aprobar")} className="btn btn-default btn-primary__submit btn-color-verdefull">Aprobar</button> */}
                            {!isRechazando && <button type="button" onClick={(e) => callCambiaEstado(parent, e, "Aprobar", "APROBADOR")} className="btn btn-default btn-primary__submit btn-color-verdefull">Aprobar</button>}
                        </div>
                        {isRechazando && renderCuadroRechazo("APROBADOR")}
                    </>
                ) : <div className="mb-2"><span style={{ fontSize: '14px', color: '#495057' }}>El documento está pendiente de aprobación</span></div>
            )}

            {estadoActual === "O" && (
                (isPublicador || isSuperAdmin) ? (
                    <>
                        <div className="mb-2"><span style={{ fontSize: '14px', color: '#495057' }}>El documento está pendiente de publicación</span></div>
                        <div className="d-flex">
                            <button type="button" onClick={() => setIsRechazando(!isRechazando)} className="btn btn-default btn-primary__submit btn-color-rojo-borde" style={{ marginRight: '10px' }}>Rechazar</button>
                            {/* <button type="button" onClick={(e) => callCambiaEstado(parent, e, "Publicar")} className="btn btn-default btn-primary__submit btn-color-verdefull">Publicar</button> */}
                            {!isRechazando && <button type="button" onClick={(e) => callCambiaEstado(parent, e, "Publicar", "PUBLICADOR")} className="btn btn-default btn-primary__submit btn-color-verdefull">Publicar</button>}
                        </div>
                        {isRechazando && renderCuadroRechazo("PUBLICADOR")}
                    </>
                ) : <div className="mb-2"><span style={{ fontSize: '14px', color: '#495057' }}>El documento está aprobado, queda pendiente la publicación</span></div>
            )}

            {estadoActual === "P" && (
                (isPublicador || isSuperAdmin) ? (
                    <>
                        <div className="mb-2"><span style={{ fontSize: '14px', color: '#495057' }}>El documento está publicado</span></div>
                        <div className="d-flex">
                            <button type="button" onClick={() => setIsRechazando(!isRechazando)} className="btn btn-default btn-primary__submit btn-color-rojo-borde" style={{ marginRight: '10px' }}>Rechazar</button>
                        </div>
                        {isRechazando && renderCuadroRechazo("PUBLICADOR")}
                    </>
                ) : <div className="mb-2"><span style={{ fontSize: '14px', color: '#495057' }}>El documento está publicado</span></div>
            )}
        </div>
    );

    function renderCuadroRechazo(rol) {
        return (
            <div className="mt-3 p-3 border rounded bg-light">
                <textarea 
                    id="motivoRechazo" name="motivoRechazo"
                    autoFocus 
                    className="form-control shadow-none border-secondary" 
                    rows="3" style={{ resize: 'none' }} 
                    value={motivoRechazo} onChange={(e) => setMotivoRechazo(e.target.value)}
                    placeholder="Ingrese el motivo de rechazo"
                    maxLength={2000}
                ></textarea>
                <label htmlFor="motivoRechazo" style={{textAlign:'right', display:'block'}}><strong><span id='count-caracteres-motivoRechazo'>{motivoRechazo.length}</span> / 2000 caracteres</strong></label>
                <div className="d-flex mt-2">
                    <button type="button" className="btn btn-default btn-color-rojo-full mr-2" style={{ marginRight: '10px' }}
                        onClick={(e) => {
                            if(motivoRechazo.trim() === ""){ toast.error("Debe ingresar el motivo de rechazo"); return; }
                            callCambiaEstado(parent, e, "Rechazar", rol, motivoRechazo); 
                            setIsRechazando(false); setMotivoRechazo("");
                        }}>Confirmar rechazo</button> 
                    <button type="button" className="btn btn-default btn-color-rojo-borde" onClick={() => { setIsRechazando(false); setMotivoRechazo(""); }}>Cancelar</button>
                </div>
            </div>
        );
    }

};

export const BotoneraCrud = ({ parent, momentoCrud }) => {
    if (parent.state.loading) return null;

    const numeroTab = parent.state.numeroTab;
  
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const config = JSON.parse(localStorage.getItem('config') || '{}');
    const userId = user.nUsuCodigo ? user.nUsuCodigo.toString() : "";

    let isSuperAdmin = user.Tusu_EsSuperAdmin === true || user.Tusu_EsSuperAdmin === "true";
    let isAprobador = config.aprobador && config.aprobador.split(',').includes(userId);
    
    const idAprobadorAsignado = parent.state.resource.nAprobador?.value || parent.state.resource.nAprobador;
    isAprobador = isAprobador && (userId === String(idAprobadorAsignado));
    
    let isPublicador = config.publicador && config.publicador.split(',').includes(userId);
    let isCreador = !isSuperAdmin && !isAprobador && !isPublicador;

    const estadoActual = parent.state.resource.cEstado?.value || parent.state.resource.cEstado || "R";
    
    //sohard: 
    // isSuperAdmin = false; isPublicador = false; isAprobador =false; isCreador = true;
    // console.log(`Abajo) estadoActual: ${estadoActual} - ROL: super: ${isSuperAdmin ? 'SI' : 'NO'} | Pub: ${isPublicador ? 'SI' : 'NO'} | Apro: ${isAprobador ? 'SI' : 'NO'} | Crea: ${isCreador ? 'SI' : 'NO'}`);
    
    return (
        <div className="d-flex gap-2">
            {/* {`numeroTab: ${numeroTab} - momentoCrud: ${momentoCrud}` } */}
            <button type="button" onClick={(e) => parent.handleClickCancel(e)} className="btn btn-default btn-primary__submit btn-color-plomo-full">
                Salir
            </button>

            { numeroTab == 4 && isSuperAdmin && momentoCrud === "edit" && (
                <ConfirmModal
                    id="inactivar-recurso-modal"
                    triggerLabel="Inactivar"
                    triggerClassName="btn btn-default btn-primary__submit btn-color-rojo-borde"
                    title="¿Confirma que desea inactivar el documento?"
                    cancelLabel="Cancelar"
                    cancelVariant="secundario2"
                    confirmLabel="Sí, inactivar"
                    confirmVariant="negativo"
                    onConfirm={(e) => callCambiaEstado(parent, e, "Inactivar", "")}
                />
            )}

            {(numeroTab < 4 )  && (
                (isCreador && (estadoActual =="Z" || estadoActual =="R") ) ? (
                    <button type="button" onClick={(e) => callCambiaEstado(parent, e, "Borrador", "")} className={`btn btn-default btn-primary__submit btn-color-verdefull`}>
                        Guardar
                    </button>
                ) : 
                (
                    ( (isSuperAdmin ) || ( 
                            ( isAprobador && estadoActual =="X") || (isPublicador && (estadoActual =="O" || estadoActual =="P"))) 
                    ) ? (
                    <button type="button" onClick={(e) => callCambiaEstado(parent, e, "GrabarCerrar", "")} className={`btn btn-default btn-primary__submit btn-color-verdefull`}>
                        Guardar
                    </button>
                    ): null
                )
            )}
        </div>
    );
};

export  const  navegarTab = (parent,direccion) => {
    const nuevoIndice = parent.state.numeroTab + direccion;
    if (nuevoIndice >= 0 && nuevoIndice <= 4) {
        parent.setState({numeroTab: nuevoIndice}, () => {
            window.scrollTo(0, 0);
        });
    }
};